import { render, staticRenderFns } from "./BRy.vue?vue&type=template&id=006eac49&scoped=true&"
import script from "./BRy.vue?vue&type=script&lang=js&"
export * from "./BRy.vue?vue&type=script&lang=js&"
import style0 from "./BRy.vue?vue&type=style&index=0&id=006eac49&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "006eac49",
  null
  
)

export default component.exports